export default class Loading {
  static load() {
    document.addEventListener("DOMContentLoaded", function() {
      document.body.classList.add('ready');
    });
  }
}
